import config from '../../src/config/config';
import communicate from '../utils/communicate';

export default {
  socket: null,
  timeOut: null,
  selfDisconnect: false,
  errorStatus: false,
  url: '',
  init(token) {
    this.url = `${config.socketUrl}?token=${token}`;
    this.socket = new WebSocket(this.url);
    this.selfDisconnect = false;
    this.pushPing();
    this.onOpen();
    this.onMessage();
    this.onError();
    this.onClose();
  },
  send(msg) {
    this.socket.send(msg);
  },
  reconnect() {
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(() => {
      this.socket = new WebSocket(this.url);
      this.selfDisconnect = false;
      this.pushPing();
      this.onOpen();
      this.onMessage();
      this.onError();
      this.onClose();
    }, 2000);
  },
  pushPing() {
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(() => {
      clearTimeout(this.timeOut);
      this.socket.send('{"type":"ping"}');
      this.pushPing();
    }, 30000);
  },
  onOpen() {
    this.socket.onopen = () => {
      this.pushPing();
      if (this.errorStatus) {
        communicate.$emit('socketOpen', true);
      }
    };
  },
  onMessage() {
    this.socket.onmessage = (event) => {
      const json = JSON.parse(event.data);
      switch (json.type) {
        case 'ping':
          this.socket.send('{"type":"pong"}');
          break;
        default:
      }
    };
  },
  onError() {
    this.socket.onerror = (err) => {
      this.errorStatus = true;
      this.reconnect();
    };
  },
  onClose() {
    this.socket.onclose = () => {
      if (!this.selfDisconnect) {
        this.reconnect();
      }
    };
  },
  onSelfDisconnect() {
    clearTimeout(this.timeOut);
    this.socket.close();
    this.selfDisconnect = true;
  },
};



// WEBPACK FOOTER //
// ./src/utils/WebSocket.js